import React from 'react';
import PropTypes from 'prop-types';

import {
  InputField,
  SelectField,
  MultiCheckboxField,
  TypeaheadField,
  ChannelField,
  DealershipField
} from './fields';
import CorpStoreField from './fields/corpStoreField';

const FormField = ({
  field,
  errors = {},
  touched = {},
  errorIcon = null,
  setFieldValue,
  setFieldTouched,
  values,
  channels
}) => {
  const {
    type,
    id,
    name,
    label,
    val,
    defaultVal,
    placeholder,
    readOnly,
    list,
    allowOptionNull,
    note
  } = field;
  switch (type) {
    case 'select':
      return (
        <SelectField
          label={label}
          errors={errors}
          touched={touched}
          name={name}
          id={id}
          list={list}
          allowOptionNull={allowOptionNull}
          errorIcon={errorIcon}
          val={val}
        />
      );
    case 'multiCheckbox':
      return (
        <MultiCheckboxField
          label={label}
          errors={errors}
          touched={touched}
          name={name}
          id={id}
          defaultVal={defaultVal}
          list={list}
          errorIcon={errorIcon}
          val={val}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
        />
      );
    case 'typeahead':
      return (
        <TypeaheadField
          label={label}
          errors={errors}
          touched={touched}
          name={name}
          id={id}
          defaultVal={defaultVal}
          list={list}
          errorIcon={errorIcon}
          val={val}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
        />
      );
    case 'channelField':
      return (
        <ChannelField
          label={label}
          errors={errors}
          touched={touched}
          name={name}
          id={id}
          defaultVal={defaultVal}
          list={list}
          onChangeHandler={(val, name) => onChangeHandler(val, name)}
          errorIcon={errorIcon}
          values={values}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          channels={channels}
        />
      );
    case 'corpStoreField':
      return (
        <CorpStoreField
          values={values}
          label={label}
          touched={touched}
          errors={errors}
          setFieldValue={setFieldValue}
        />
      );
    case 'dealershipField':
      return (
        <DealershipField
          label={label}
          errors={errors}
          touched={touched}
          values={values}
          defaultVal={defaultVal}
          onChangeHandler={(val, name) => onChangeHandler(val, name)}
          dealershipNames={list}
          setFieldValue={setFieldValue}
        />
      );
    default:
      return (
        <InputField
          label={label}
          errors={errors}
          touched={touched}
          name={name}
          placeholder={placeholder}
          readOnly={readOnly}
          type={type}
          setFieldValue={setFieldValue}
          note={note}
        />
      );
  }
};

FormField.propTypes = {
  field: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    val: PropTypes.string,
    defaultVal: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.any)
    ]),
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    list: PropTypes.arrayOf(PropTypes.any),
    allowOptionNull: PropTypes.bool
  }).isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  errorIcon: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  channels: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default FormField;
